import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, TextField, Button, Card, CardContent } from '@mui/material';
import axios from 'axios';
import Nlayout from './Nlayout';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
export default function CrearSorteo() {
    const [titulo, setTitulo] = useState('');
    const [clave, setClave] = useState('');
    const [video, setVideo] = useState('');
    const [premios, setPremios] = useState('');
    const [keyword, setKeyword] = useState('');
    const [tipo, setTipo] = useState('Normal');
    const [casino, setCasino] = useState('1xBet');

    const navigate = useNavigate();

    const handleCrear = async () => {
        try {
            const response = await axios.post('https://backend.eldenguee.com/sorteo', {
                titulo,
                premios,
                clave,
                video,
                tipo,
                keyword,
                casino
            });

            const { id, url } = response.data;
            navigate(`/sorteo/${id}${clave ? `?fb=${encodeURIComponent(clave)}` : ''}`);
        } catch (error) {
            console.error('Error al crear sorteo:', error);
            alert('Hubo un error al crear el sorteo.');
        }
    };

    const handleChange = (event) => {
        setTipo(event.target.value);
    };
    const handleChangec = (event) => {
        setCasino(event.target.value);
    };
    return (
        <Nlayout>
            <Box p={4} style={{ width: '100%', padding: '100px 0px' }}>
                <Card>
                    <CardContent style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <Typography variant="h5" gutterBottom>Crear sorteo</Typography>
                        <TextField
                            fullWidth
                            label="Título"
                            margin="normal"
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                        />
                        <TextField
                            fullWidth
                            type="number"
                            label="Cantidad de premios"
                            margin="normal"
                            value={premios}
                            onChange={(e) => setPremios(e.target.value)}
                        />

                        <TextField
                            fullWidth
                            label="Palabra Clave"
                            margin="normal"
                            value={clave}
                            onChange={(e) => setClave(e.target.value)}
                        />

                        <TextField
                            fullWidth
                            label="URL video"
                            margin="normal"
                            value={video}
                            onChange={(e) => setVideo(e.target.value)}
                        />

                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Tipo de Sorteo</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={tipo}
                                label="Tipo de Sorteo"
                                onChange={handleChange}
                            >
                                <MenuItem value={'Normal'}>Normal</MenuItem>
                                <MenuItem value={'Suscriptores'}>Suscriptores</MenuItem>
                                <MenuItem value={'Chat'}>Chat</MenuItem>
                                <MenuItem value={'Manual'}>Manual</MenuItem>
                                <MenuItem value={'ID'}>ID Blockchain</MenuItem>

                            </Select>
                        </FormControl>
                        {tipo === 'Chat' &&
                            <TextField
                                fullWidth
                                label="Keyword para el chat"
                                margin="normal"
                                value={keyword}
                                onChange={(e) => setKeyword(e.target.value)}
                            />
                        }
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Casino</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={casino}
                                label="Casino"
                                onChange={handleChangec}
                            >
                                <MenuItem value={'1xBet'}>1xBet</MenuItem>
                                <MenuItem value={'BetWinner'}>BetWinner</MenuItem>
                            </Select>
                        </FormControl>
                        <Button variant="contained" color="primary" fullWidth onClick={handleCrear}>
                            Crear
                        </Button>
                    </CardContent>
                </Card>
            </Box>
        </Nlayout>
    );
}
